export default __webpack_public_path__ + "static/media/np-tip.953b6e66.png";